module.exports = __webpack_public_path__ + "static/img/content6.ae59f6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mo/zh/content6.png
// module id = phFb
// module chunks = 1 3